import moment from 'moment';
import { momentFromApi } from 'src/utils/taskDateUtils';

export function normaliseTaskTitle(title) {
    return typeof title === 'string' ? title.trim() : '';
}

export function hasDueDateChanged(currentDueAt, nextDate) {
    if (!(nextDate instanceof Date) || Number.isNaN(nextDate.getTime())) return false;

    const current = momentFromApi(currentDueAt);
    if (!current || !current.isValid()) return true;

    const next = moment(nextDate);
    if (!next.isValid()) return false;

    return Math.floor(current.valueOf() / 60000) !== Math.floor(next.valueOf() / 60000);
}

export function getTaskRenamePlan(item, nextDate, nextTitle) {
    const parsedTitle = normaliseTaskTitle(nextTitle);
    const currentTitle = normaliseTaskTitle(item?.title);
    const isStandalone = !!item?.isStandaloneTask;
    const isChecklistItem = !!item?.itemId && !item?.isStandaloneTask;
    const titleChanged = !!parsedTitle && parsedTitle !== currentTitle && (isStandalone || isChecklistItem);

    return {
        dueDateChanged: hasDueDateChanged(item?.due_at, nextDate),
        isChecklistItem,
        isStandalone,
        titleChanged,
        title: parsedTitle,
    };
}
